import { createActions } from "reduxsauce";
import { PARAMS, DATA, RESOLVE, REJECT } from "./constants";

const PACK_ID = "packId";

const { Types, Creators } = createActions({
  getContentPacksFailure: null,
  getContentPacksRequest: [PARAMS],
  getContentPacksSuccess: [DATA],

  createContentPackFailure: null,
  createContentPackRequest: [DATA, RESOLVE, REJECT],
  createContentPackSuccess: [DATA],

  updateContentPackFailure: null,
  updateContentPackRequest: [PACK_ID, DATA, RESOLVE, REJECT],
  updateContentPackSuccess: [DATA],

  deleteContentPackFailure: null,
  deleteContentPackRequest: [PACK_ID],
  deleteContentPackSuccess: [PACK_ID],

  publishContentPackFailure: null,
  publishContentPackRequest: [PACK_ID],
  publishContentPackSuccess: [DATA],

  unpublishContentPackFailure: null,
  unpublishContentPackRequest: [PACK_ID],
  unpublishContentPackSuccess: [DATA],

  getContentTagsFailure: null,
  getContentTagsRequest: null,
  getContentTagsSuccess: [DATA],

  editContentPack: [PACK_ID],
  closeContentPackForm: null,
});

export const CollegeContentTypes = Types;
export const CollegeContentCreators = Creators;
